import React, { Component } from 'react';
import axiosInstance from '@src/axios-instance';

class NameInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      active: false,
      value: props.value,
      defaultValue: props.value,
      inputClass: ''
    };
  }

  saveInput = () => {
    if (this.state.value.length < 1) {
      return false;
    }

    axiosInstance()
      .put(`/sample-quote-regions/${this.props.entityId}.json`, {
        name: this.state.value
      })
      .then(response => {
        this.setState({
          active: false,
          inputClass: ''
        });
      })
      .catch(err => {});
  };

  render = () => {
    return (
      <div>
        <input
          value={this.state.value}
          className={'form-control ' + this.state.inputClass}
          style={
            this.state.active
              ? { width: '300px' }
              : {
                  borderColor: 'transparent',
                  backgroundColor: 'transparent',
                  width: '300px'
                }
          }
          readOnly={!this.state.active}
          onClick={() => {
            this.setState({
              active: true
            });
          }}
          onChange={e =>
            this.setState({
              active: true,
              value: e.currentTarget.value,
              inputClass:
                e.currentTarget.value.length > 0 ? 'is-valid' : 'is-invalid'
            })
          }
          onBlur={this.saveInput}
        />
      </div>
    );
  };
}

export default NameInput;
